import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";

var _templateObject, _templateObject2;

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import useSWR from 'swr';
import NextLink from 'next/link';
import Image from 'next/legacy/image';
import styled from 'styled-components';
import { useState, useRef, useCallback } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from '@yoweb/next-i18next';
import { withPageTitle } from '@poplar/components/withPageTitle';
import { EducationModal } from '@poplar/components/EducationModal';
import { fetcher } from '@yoweb/utils/common';
import { API_TASK_TEMPLATE_HOME, API_TASK_TEMPLATE_HOME_CATEGORY, PAGE_TEMPLATE_DETAILS, PAGE_TODO } from '@poplar/constants/routes';
import { Title, Text, Label } from '@yoweb/ui/components/typography';
import { Box } from '@yoweb/ui/components/Box';
import { Flex } from '@yoweb/ui/components/Flex';
import { Grid } from '@yoweb/ui/components/Grid';
import { useUser } from '@poplar/hooks/useUser';
import { useFeedbackToast } from '@poplar/hooks/useFeedbackToast';
import { AccessType } from '@poplar/types/enums';
import { Link } from '@yoweb/ui/components/Link';
import { Button } from '@yoweb/ui/components/buttons';
import { CaretRightThickIcon } from '@yoweb/ui/components/Icon/CaretRightThickIcon';
import { LargeFeatureCard } from '@poplar/components/TaskTemplate/LargeFeatureCard';
import { TaskActionCard } from '@poplar/components/Home/TaskActionCard';
import { useEntitlement } from '@poplar/contexts/EntitlementProvider';
import { useTasks } from '@poplar/contexts/TaskContext/TaskProvider';
import { FeedbackFlyout } from '@poplar/components/tasks/Feedback/Flyout';
import { RenderOn } from '@yoweb/ui/components/RenderOn/RenderOn';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { FooterBannerUnsubscribed } from '@poplar/components/Home/FooterBannerUnsubscribed';
import { FooterBannerSubscribed } from '@poplar/components/Home/FooterBannerSubscribed';
import { CallCard } from '@poplar/components/CallCard';
import { personNameWithFallback } from '@poplar/utils/user';
import { getSpace, th } from '@yoweb/ui/styles/utils/theme';
import { CardCarousel, useCardCarouselStepper } from '@poplar/components/CardCarouselFixed';
import { CardCarouselNav } from '@poplar/components/CardCarouselNav';
import { useMemberActions } from '@poplar/contexts/MemberActionsProvider';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { convertTimeProtoToTimestamp } from '@yoweb/utils/converters';
import { TodoEntryPoint, TodoType } from '@yoweb/types/external-events';
import CategoryRow from '@poplar/components/Home/CategoryRow';
import { FEATURE_ENABLE_HOME_NEW_CATEGORIES } from '@poplar/constants/split';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SUBSCRIPTION_TYPES_WITH_MEMBER_ACTIONS = [AccessType.FULL, AccessType.LIMITED, AccessType.PAUSED];

var groupIntoTuplesReducer = function groupIntoTuplesReducer(result, _value, index, array) {
  if (index % 2 === 0) result.push(array.slice(index, index + 2));
  return result;
};

var HomePage = function HomePage(_ref) {
  var _categories$filter, _feedbackState$taskFe2;

  var feedbackCategories = _ref.feedbackCategories,
      homeCategories = _ref.homeCategories,
      homeFeaturedTodos = _ref.homeFeaturedTodos,
      treatments = _ref.treatments;

  var _useTranslation = useTranslation('home'),
      t = _useTranslation.t;

  var router = useRouter();
  var carouselRef = useRef(null);

  var _useUser = useUser(),
      profile = _useUser.profile,
      isAuthenticated = _useUser.isAuthenticated;

  var isNewCategoriesEnabled = (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_ENABLE_HOME_NEW_CATEGORIES]) === 'on';

  var _useState = useState({
    taskFeedback: null,
    initialRating: 0,
    visible: false
  }),
      feedbackState = _useState[0],
      setFeedbackState = _useState[1];

  var _useMemberActions = useMemberActions(),
      actionItems = _useMemberActions.state.actionItems,
      refreshMemberActions = _useMemberActions.actions.refreshMemberActions;

  var _useSWR = useSWR(isAuthenticated ? API_TASK_TEMPLATE_HOME : undefined, fetcher, {
    fallbackData: homeFeaturedTodos,
    revalidateOnFocus: false
  }),
      featuredTodos = _useSWR.data,
      refetchFeaturedTodos = _useSWR.mutate;

  var _useSWR2 = useSWR(isAuthenticated ? API_TASK_TEMPLATE_HOME_CATEGORY : undefined, fetcher, {
    fallbackData: homeCategories,
    revalidateOnFocus: false
  }),
      categories = _useSWR2.data;

  var _useEntitlement = useEntitlement(),
      accessType = _useEntitlement.accessType;

  var supportsMemberActions = SUBSCRIPTION_TYPES_WITH_MEMBER_ACTIONS.includes(accessType);

  var _useTasks = useTasks(),
      _useTasks$actions = _useTasks.actions,
      openTaskIntakeModalForTemplateId = _useTasks$actions.openTaskIntakeModalForTemplateId,
      openTaskIntakeModalForCategoryId = _useTasks$actions.openTaskIntakeModalForCategoryId;

  var isUnsubscribed = accessType === AccessType.PREVIEW;
  var topActionItems = actionItems.slice(0, 3);
  var otherActionItemCount = Math.max(actionItems.length - topActionItems.length, 0);

  var onClickTodoTemplate = function onClickTodoTemplate(templateId, skipPdp) {
    if (skipPdp) {
      openTaskIntakeModalForTemplateId(templateId);
      return;
    }

    void router.push(PAGE_TEMPLATE_DETAILS(templateId));
  };

  var _useCardCarouselStepp = useCardCarouselStepper(carouselRef),
      onNext = _useCardCarouselStepp.onNext,
      onBack = _useCardCarouselStepp.onBack,
      backwardEnabled = _useCardCarouselStepp.backwardEnabled,
      forwardEnabled = _useCardCarouselStepp.forwardEnabled;

  var perferredName = personNameWithFallback(profile === null || profile === void 0 ? void 0 : profile.personName);
  var openFeedbackFlyout = useCallback(function (taskFeedback, initialRating) {
    setFeedbackState({
      taskFeedback: taskFeedback,
      initialRating: initialRating,
      visible: true
    });
  }, []);

  var _useFeedbackToast = useFeedbackToast(openFeedbackFlyout),
      dismissPrompt = _useFeedbackToast.dismissPrompt,
      isError = _useFeedbackToast.isError,
      isFetchSuccessful = _useFeedbackToast.isFetchSuccessful;

  var handleFlyoutClose = function handleFlyoutClose() {
    var _feedbackState$taskFe;

    setFeedbackState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        visible: false
      });
    });

    if ((_feedbackState$taskFe = feedbackState.taskFeedback) !== null && _feedbackState$taskFe !== void 0 && _feedbackState$taskFe.taskId && !isError && isFetchSuccessful) {
      void dismissPrompt(feedbackState.taskFeedback.taskId);
    }
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(featuredTodos === null || featuredTodos === void 0 ? void 0 : featuredTodos.largeCardsList) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(TitleContainer, {
        children: [/*#__PURE__*/_jsxs(TextContainer, {
          children: [/*#__PURE__*/_jsx(Title, {
            size: "sm",
            style: {
              width: '100%'
            },
            children: t(perferredName ? 'title' : 'for-you', {
              firstName: perferredName
            })
          }), /*#__PURE__*/_jsx(Text, {
            style: {
              width: '100%'
            },
            children: t('description')
          })]
        }), /*#__PURE__*/_jsx(NavWrapper, {
          children: /*#__PURE__*/_jsx(CardCarouselNav, {
            onNext: onNext,
            onPrevious: onBack,
            backwardEnabled: backwardEnabled,
            forwardEnabled: forwardEnabled
          })
        })]
      }), /*#__PURE__*/_jsx(CardCarousel, {
        carouselRef: carouselRef,
        children: featuredTodos.largeCardsList.map(function (card) {
          return /*#__PURE__*/_jsx(Box, {
            height: "100%",
            children: /*#__PURE__*/_jsx(LargeFeatureCard, {
              card: card,
              cursor: "pointer",
              onBookmarkUpdate: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return refetchFeaturedTodos();

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })),
              onClick: function onClick() {
                onClickTodoTemplate(card.taskTemplateId, card.skipPdp);
                trackEvent({
                  todoStart: {
                    title: card.title,
                    entryPoint: TodoEntryPoint.TODO_ENTRY_POINT_HOME_FEATURE,
                    type: TodoType.TODO_TYPE_A
                  }
                });
              }
            })
          }, card.taskTemplateId);
        })
      })]
    }), supportsMemberActions && topActionItems.length > 0 && /*#__PURE__*/_jsxs(Grid, {
      gap: "normal1",
      children: [/*#__PURE__*/_jsxs(Box, {
        mt: "medium2",
        children: [/*#__PURE__*/_jsx(Title, {
          size: "sm",
          children: t('action-items', {
            count: actionItems.length
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: "space-between",
          columnGap: "small3",
          children: [/*#__PURE__*/_jsx(Text, {
            children: t('action-items-description')
          }), /*#__PURE__*/_jsx(RenderOn.Desktop, {
            children: otherActionItemCount > 0 && /*#__PURE__*/_jsx(Link, {
              href: PAGE_TODO,
              hasUnderline: true,
              "data-testid": "more-action-items",
              children: t('more-action-items', {
                count: otherActionItemCount
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Grid, {
        columns: {
          _: 'auto',
          lg: 'repeat(3, minmax(0, 1fr))'
        },
        gap: "normal1",
        children: topActionItems.map(function (task) {
          return /*#__PURE__*/_jsx(TaskActionCard, {
            task: task,
            onFeedbackRating: function onFeedbackRating(rating) {
              setFeedbackState({
                initialRating: rating,
                taskFeedback: {
                  name: task.name,
                  taskId: task.taskId,
                  updated: convertTimeProtoToTimestamp(task.updatedTimestamp),
                  taskIsRepeatable: task.isRepeatable,
                  taskIsRepeating: task.isRepeating
                },
                visible: true
              });
            },
            onCallCardClick: function onCallCardClick() {
              openFeedbackFlyout({
                taskId: task.taskId,
                name: task.name,
                updated: convertTimeProtoToTimestamp(task.updatedTimestamp),
                taskIsRepeatable: task.isRepeatable,
                taskIsRepeating: task.isRepeating
              }, 0);
            }
          }, task.taskId);
        })
      }), otherActionItemCount > 0 && /*#__PURE__*/_jsx(RenderOn.MobileAndTablet, {
        children: /*#__PURE__*/_jsx(Flex, {
          justifyContent: "center",
          justifyItems: "center",
          children: /*#__PURE__*/_jsx(NextLink, {
            href: PAGE_TODO,
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/_jsx(Button, {
              as: "a",
              variant: "secondary",
              "data-testid": "more-action-items-tablet",
              children: t('more-action-items', {
                count: otherActionItemCount
              })
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      mt: "medium2",
      mb: "normal1",
      children: [/*#__PURE__*/_jsx(Title, {
        size: "sm",
        children: t('browse-categories')
      }), /*#__PURE__*/_jsx(Text, {
        children: t('browse-categories-description')
      })]
    }), isNewCategoriesEnabled ? categories === null || categories === void 0 ? void 0 : (_categories$filter = categories.filter(function (c) {
      return c.listCardsList.length > 0;
    })) === null || _categories$filter === void 0 ? void 0 : _categories$filter.reduce(groupIntoTuplesReducer, []).map(function (categoryTuple, i) {
      return /*#__PURE__*/_jsx(Box, {
        mb: "normal1",
        children: /*#__PURE__*/_jsx(CategoryRow, {
          firstCategory: categoryTuple[0],
          secondCategory: categoryTuple[1]
        })
      }, i);
    }) : categories === null || categories === void 0 ? void 0 : categories.map(function (category, i) {
      var _category$topListCard2, _category$topListCard3;

      return category.listCardsList.length > 0 ? /*#__PURE__*/_jsxs(Box, {
        mb: "normal3",
        children: [/*#__PURE__*/_jsxs(CategoryContainer, {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          mb: "normal1",
          "data-testid": "category-container",
          onClick: function onClick() {
            var _category$topListCard;

            if ((_category$topListCard = category.topListCard) !== null && _category$topListCard !== void 0 && _category$topListCard.id) {
              openTaskIntakeModalForCategoryId(category.topListCard.id);
              trackEvent({
                todoCategoryView: {
                  categoryTitle: category.topListCard.name
                }
              });
            }
          },
          children: [((_category$topListCard2 = category.topListCard) === null || _category$topListCard2 === void 0 ? void 0 : _category$topListCard2.iconImageUrl) && /*#__PURE__*/_jsx(Image, {
            src: category.topListCard.iconImageUrl,
            width: 22,
            height: 22
          }), /*#__PURE__*/_jsx(CategoryTitle, {
            size: "xs",
            lineHeight: "titleXs",
            children: (_category$topListCard3 = category.topListCard) === null || _category$topListCard3 === void 0 ? void 0 : _category$topListCard3.name
          }), /*#__PURE__*/_jsx(CaretRightThickIcon, {
            size: 12
          })]
        }), /*#__PURE__*/_jsx(Grid, {
          columns: {
            _: 'auto',
            md: 'repeat(2, minmax(0, 1fr))',
            lg: 'repeat(3, minmax(0, 1fr))'
          },
          gap: "normal1",
          children: category.listCardsList.map(function (subCategory) {
            return /*#__PURE__*/_jsxs(CategoryCard, {
              display: "flex",
              flexDirection: "row",
              gap: "small4",
              radii: "small",
              justifyContent: "flex-start",
              alignItems: "center",
              "data-testid": "subcategory-card",
              onClick: function onClick() {
                onClickTodoTemplate(subCategory.taskTemplateId, subCategory.skipPdp);
                trackEvent({
                  todoStart: {
                    title: subCategory.name,
                    entryPoint: TodoEntryPoint.TODO_ENTRY_POINT_HOME_SUBCATEGORY,
                    type: TodoType.TODO_TYPE_B
                  }
                });
              },
              hoverable: true,
              children: [subCategory.isTaskTemplateForDogfoodTesting && /*#__PURE__*/_jsx(Tag, {
                "data-testid": "tag-testing",
                children: /*#__PURE__*/_jsx(CenteredLabel, {
                  children: t('subcategory-testing-badge')
                })
              }), /*#__PURE__*/_jsx(Text, {
                size: "md",
                weight: "semibold",
                children: subCategory.name
              })]
            }, subCategory.id);
          })
        })]
      }, i) : null;
    }), isUnsubscribed ? /*#__PURE__*/_jsx(FooterBannerUnsubscribed, {}) : /*#__PURE__*/_jsx(FooterBannerSubscribed, {}), /*#__PURE__*/_jsx(EducationModal, {}), /*#__PURE__*/_jsx(FeedbackFlyout, {
      taskFeedback: feedbackState.taskFeedback,
      isOpen: feedbackState.visible,
      feedbackCategories: feedbackCategories,
      initialRating: feedbackState.initialRating,
      onClose: handleFlyoutClose,
      onSubmitted: function onSubmitted() {
        void refreshMemberActions();
      }
    }, (_feedbackState$taskFe2 = feedbackState.taskFeedback) === null || _feedbackState$taskFe2 === void 0 ? void 0 : _feedbackState$taskFe2.taskId)]
  });
};

HomePage.layout = {
  type: 'poplar',
  props: {
    withTransparentHeader: false
  }
};
export var __N_SSP = true;
export default _withSuperJSONPage(withPageTitle(HomePage)({
  translationKey: 'page-title',
  translationNS: 'home'
}));
var CategoryCard = styled(CallCard).withConfig({
  componentId: "sc-1ibp990-0"
})(["&&{cursor:pointer;min-height:72px;word-break:break-word;}"]);
var CategoryContainer = styled(Box).withConfig({
  componentId: "sc-1ibp990-1"
})(["&&{cursor:pointer;}"]);
var NavWrapper = styled.div.withConfig({
  componentId: "sc-1ibp990-2"
})(["float:right;margin-left:auto;margin-top:auto;", " ", ""], media.xs(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))), media.sm(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n  "]))));
var TitleContainer = styled.div.withConfig({
  componentId: "sc-1ibp990-3"
})(["display:flex;flex-flow:row nowrap;margin-bottom:", ";flex:auto;"], getSpace('normal1'));
var TextContainer = styled.div.withConfig({
  componentId: "sc-1ibp990-4"
})(["display:flex;flex-flow:row wrap;"]);
var CategoryTitle = styled(Title).withConfig({
  componentId: "sc-1ibp990-5"
})(["height:", ";margin-left:", ";margin-right:", ";"], pxToRem(21), getSpace('small3'), getSpace('small2'));
var Tag = styled.div.withConfig({
  componentId: "sc-1ibp990-6"
})(["display:flex;justify-content:center;align-items:center;background-color:", ";padding:", ";border-radius:", ";"], th.getColor('warningLight'), th.getSpace('small3'), th.getRadii('tiny'));
var CenteredLabel = styled(Label).withConfig({
  componentId: "sc-1ibp990-7"
})(["letter-spacing:normal;"]);